import { useEffect, useState } from 'react';
import placeholderImage from '../images/placeholder.webp';

const EpisodeCard = ({ episode, onRemove }) => {
    const [duration, setDuration] = useState('');
    function getVideoLength(videoUrl, isVideo) {
        return new Promise((resolve, reject) => {
            const video = document.createElement(isVideo ? 'video' : 'audio');
            video.preload = 'metadata';
        
            video.onloadedmetadata = function() {
                resolve(video.duration);
                video.remove();
            };
        
            video.onerror = function() {
                reject('Err');
                video.remove();
            };
      
            video.src = videoUrl;
        });
    }
    useEffect(() => {
        if (episode.mediaUrl) {
            getVideoLength(episode.mediaUrl.startsWith('http') ? episode.mediaUrl : process.env.REACT_APP_MEDIA_URL + episode.mediaUrl)
                .then(d => {
                    var min = (d / 60) | 0;
                    var hours = (d / 60) | 0;
                    min = min - hours * 60;
                    var seconds = (d - min * 60 - hours * 3600) | 0;
                    var timeString = '';
                    if (hours) {
                        if (min)
                            timeString = `${hours}h ${min}min`;
                        else
                            timeString = hours + 'h';
                    } else {
                        if (min) {
                            if (seconds)
                                timeString = `${min}min ${seconds}s`;
                            else
                                timeString = min + 'min';
                        } else {
                            timeString = seconds + 's';
                        }
                    }
                    setDuration(timeString);
                });
        }
    }, [episode.mediaUrl]);
    return (
        <div className="episode-card">
            {onRemove ? (
                <button className="episode-remove" onClick={() => onRemove(episode.id)}>
                    {'\u00D7'}
                </button>
            ) : null}
            <img src={episode.imageUrl ? (episode.imageUrl.startsWith('http') ? episode.imageUrl : process.env.REACT_APP_MEDIA_URL + episode.imageUrl) : episode.images.length > 0 ? (episode.images[0].imageUrl.startsWith('http') ? episode.images[0].imageUrl : process.env.REACT_APP_MEDIA_URL + episode.images[0].imageUrl) : placeholderImage}
                alt={episode.title} />
            <div className="episode-info">
                <div className="episode-title">{episode.title}</div>
                <div className="episode-description">{episode.description}</div>
                <div className="episode-air-date">
                    {(new Date(episode.airDate)).toLocaleDateString('en-US', {month: 'short', day: 'numeric', year: 'numeric',})} {'\u2022'} {duration ? duration + ' \u2022' : ''} {episode.season ? 'S' + episode.season : null} Ep{episode.episode}
                </div>
            </div>
        </div>
    );
}

export default EpisodeCard;